<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M9.0102734375,14C9.0102734375,14,7.0102734375,14,7.0102734375,14C6.4602734375,14,6.0102734375,14.45,6.0102734375,15C6.0102734375,15.55,6.4602734375,16,7.0102734375,16C7.0102734375,16,9.0102734375,16,9.0102734375,16C9.560273437500001,16,10.0102734375,15.55,10.0102734375,15C10.0102734375,14.45,9.5702734375,14,9.0102734375,14C9.0102734375,14,9.0102734375,14,9.0102734375,14ZM10.0102734375,11C10.0102734375,11,6.0102734375,11,6.0102734375,11C5.4602734375,11,5.0102734375,11.45,5.0102734375,12C5.0102734375,12.55,5.4602734375,13,6.0102734375,13C6.0102734375,13,10.0102734375,13,10.0102734375,13C10.560273437500001,13,11.0102734375,12.55,11.0102734375,12C11.0102734375,11.45,10.5702734375,11,10.0102734375,11C10.0102734375,11,10.0102734375,11,10.0102734375,11ZM8.0102734375,0C5.2602734375,0,3.0302734375,1.95,3.0302734375,4.35C3.0302734375,6.72,4.6602734375,6.99,4.9702734374999995,9.57C4.9702734374999995,9.57,4.9702734374999995,9.57,4.9702734374999995,9.57C4.9702734374999995,9.81,5.1902734375,10.01,5.4702734374999995,10.01C5.4702734374999995,10.01,10.560273437500001,10.01,10.560273437500001,10.01C10.840273437499999,10.01,11.0602734375,9.82,11.0602734375,9.57C11.3702734375,6.99,13.0002734375,6.72,13.0002734375,4.35C13.0002734375,1.95,10.7702734375,0,8.0102734375,0C8.0102734375,0,8.0102734375,0,8.0102734375,0Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'Lightbulb',
} as DefineComponent
</script>
